import { Diagnosis } from '@/models';
import { GenericService } from './generic.service';

export class PatientReviewDiagnosisService extends GenericService<Diagnosis> {
  constructor(patientId: string, reviewId: string) {
    super();
    this.endpoint = `v1/patients/${patientId}/reviews/${reviewId}/diagnoses`;
  }
}
